<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-04-27 20:52:20
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-04-27 20:54:00
 * @FilePath: /goldenSalesMobile/src/components/CopyRight/index.vue
 * @Description: 版权说明组件
-->
<template>
  <div class="copyright">
    <van-divider
      content-position="center"
      :style="{fontSize: '13px', fontWeight: 600, color: '#D3D5DD'}"
    >
      <span>金贵让一切更简单</span>
    </van-divider>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.copyright {
  position: absolute;
  left: 0;
  bottom: 110px;
  z-index: 1;
  width: 100%;

  span {
    position: relative;

    &::before,&::after {
      position: absolute;
      top: 50%;
      z-index: 1;
      content: '';
      width: 16px;
      height: 24px;
      margin-top: -12px;
      background: url('../../../assets/common_image/sub_logo.png');
      background-size: cover;
    }

    &::before {
      left: -20px;
    }

    &::after {
      right: -20px;
    }
  }
}
</style>